import { MsalInstance } from '@trukt/auth-web/MsalInstance';

export const msalInstance = new MsalInstance({
  clientId: process.env.CLIENT_ID,
  policy: process.env.POLICY,
});
